import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { UpdateTeltonikaSNMPUser } from 'libs/shared/src/interfaces/TeltonikaSNMPUser';
import { MaterialModule } from '@huge-monorepo/shared/modules';

@Component({
  selector: 'huge-monorepo-teltonika-edit-snmp-user-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MaterialModule],
  templateUrl: './teltonika-edit-snmp-user-modal.component.html',
  styleUrl: './teltonika-edit-snmp-user-modal.component.scss',
})
export class TeltonikaEditSnmpUserModalComponent implements OnInit {
  form: FormGroup = this.formBuilder.group({
    Enabled: new FormControl(false, []),
    Username: new FormControl(null, [Validators.required]),
    Rights: new FormControl(null, [Validators.required]),
    MibAccess: new FormControl(null, []),
    SecLevel: new FormControl(null, [Validators.required]),
    AuthType: new FormControl(null, [Validators.required]),
    AuthPass: new FormControl(null, [Validators.required]),
    PrivType: new FormControl(null, []),
    PrivPass: new FormControl(null, []),
  });

  constructor(
    public dialogRef: MatDialogRef<TeltonikaEditSnmpUserModalComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: UpdateTeltonikaSNMPUser,
  ) {
    if (this.data) {
      this.form.patchValue(this.data);
    }
  }
  ngOnInit(): void {
    this.form.get('SecLevel')?.valueChanges.subscribe((value) => {
      if (value == null) {
        this.form.get('AuthType')?.disable();
        this.form.get('AuthPass')?.disable();
        this.form.get('PrivType')?.disable();
        this.form.get('PrivPass')?.disable();
      } else if (value === 'noauth') {
        this.form.get('AuthType')?.setValue(null);
        this.form.get('AuthPass')?.setValue(null);
        this.form.get('PrivType')?.setValue(null);
        this.form.get('PrivPass')?.setValue(null);
        this.form.get('AuthType')?.disable();
        this.form.get('AuthPass')?.disable();
        this.form.get('PrivType')?.disable();
        this.form.get('PrivPass')?.disable();
      } else if (value === 'auth') {
        this.form.get('PrivType')?.setValue(null);
        this.form.get('PrivPass')?.setValue(null);
        this.form.get('AuthType')?.enable();
        this.form.get('AuthPass')?.enable();
        this.form.get('PrivType')?.disable();
        this.form.get('PrivPass')?.disable();
      } else if (value === 'priv') {
        this.form.get('AuthType')?.enable();
        this.form.get('AuthPass')?.enable();
        this.form.get('PrivType')?.enable();
        this.form.get('PrivPass')?.enable();
      }
    });
  }

  close(save: boolean) {
    const result = save ? this.data != null ? {ID: this.data.ID, ...this.form.value} : this.form.value : null;
    this.dialogRef.close(result);
  }
}
